<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="image-list-container">
	<div class="thumbnail-grid">
		<div
			*ngIf="attachedFilesService.editable$ | async"
			class="add-file"
			[ngClass]="{
				disabled: (attachedFilesService.viewState$ | async) === attachmentsViewState.MultiSelectMode
			}"
			(click)="fileInput.click()"
		>
			<mat-icon>add</mat-icon>
			<input
				#fileInput
				type="file"
				accept="{{ acceptedFileExtensions }}"
				multiple
				class="file-uploader"
				(change)="attachFiles($event.target.files)"
				(click)="$event.target.value = null"
			/>
		</div>
		<attached-file-viewer
			*ngFor="let file of attachedFilesService.file$ | async"
			[file]="file"
			[showBorder]="false"
			(fileClicked)="fileClickHandler($event)"
			(fileSelected)="fileSelectedHandler($event)"
		>
		</attached-file-viewer>
	</div>
</div>
